// extracted by mini-css-extract-plugin
module.exports = {"Product2JP":"Product2JP_Product2JP__doVt3"};